import { editorDraftHasContent } from './editorDraftHasContent';
export const editorStateHasContent = (editorState, attachments) => {
  const hasAttachments = attachments && attachments.size > 0;
  const notEmpty = editorDraftHasContent(editorState);
  return hasAttachments || notEmpty;
};